import styled from 'styled-components';

export const Input = styled.input`
	margin-top: 4px;
	display: flex;
	padding: 8px 10px 8px 10px;
	width: 260px;
	align-items: center;
	border-radius: 8px;
	border: 1px solid #29185e;
	background: #fff;

	&:hover {
		outline: none;
	}
	&:focus {
		outline: none;
	}
`;

export const EmailBox = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	margin-top: 10px;
	min-width: 80vw;

	@media (min-width: 600px) {
		min-width: 550px;
		max-width: 550px;
		align-items: flex-start;
	}
`;

export const InputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const Label = styled.label`
	color: #868686;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 16.8px */
`;

export const HintMail = styled.div`
	float: right;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: left;

	margin-top: -5px;
	padding-top: 5px;
	padding-left: 10px;
	min-height: 40px;
	height: fit-content;
	width: 300px;
	flex-shrink: 0;
	border-radius: 0px 0px 16px 16px;
	background: linear-gradient(10deg, #48068a 10%, #4322c6 65%);
	cursor: pointer;
	gap: 5px;
	text-align: left;

	color: #fff;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-align: left;
	z-index: 3;
	box-sizing: border-box;

	@media (max-width: 600px) {
		width: 80vw;
	}
`;

export const FormatMailCorrection = styled.div`
	color: #fff;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	text-decoration-line: underline;
`;

export const StyledInput = styled(Input)`
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	color: #29185e;
	width: 80vw;
	box-sizing: border-box;

	@media (min-width: 600px) {
		width: 300px;
	}
`;
